import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const EditShopBanner = () => {
  const { _id } = useParams();
  const [btnLoading, setBtnLoading] = useState(false);

  const [data, setData] = useState({
    saleBannerTitle: "",
    image: "",
    active: false
  });

  const [preview, setPreview] = useState("");

  // fetch existing banner
  const getBanner = async () => {
    try {
      const res = await axios.get(`https://api.assortsmachinetools.com/api/shop-banner/${_id}`);
      setData(res.data.data);
      setPreview(res.data.data.image);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getBanner();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    if (type === "file") {
      const file = files[0];
      setData({ ...data, image: file });
      setPreview(URL.createObjectURL(file)); // 👈 instant preview
    } else if (type === "checkbox") {
      setData({ ...data, [name]: checked });
    } else {
      setData({ ...data, [name]: value });
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    setBtnLoading(true);

    try {
      const formData = new FormData();
      formData.append("saleBannerTitle", data.saleBannerTitle);
      formData.append("active", data.active);
      if (data.image instanceof File) {
        formData.append("image", data.image);
      }

      await axios.put(
        `https://api.assortsmachinetools.com/api/shop-banner/${_id}`,
        formData
      );

      alert("Shop Banner Updated");
    } catch (err) {
      console.error(err);
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />

      <div className="bread">
        <div className="head">
          <h4>Edit Shop Banner</h4>
        </div>
        <div className="links">
          <Link to="/all-shop-banners" className="add-new">
            Back <i className="fa-regular fa-circle-left"></i>
          </Link>
        </div>
      </div>

      <div className="d-form">
        <form className="row g-3" onSubmit={submitHandler}>

          <div className="col-md-4">
            <label className="form-label">Shop Banner Name</label>
            <input
              type="text"
              name="saleBannerTitle"
              value={data.saleBannerTitle}
              onChange={handleChange}
              className="form-control"
            />
          </div>

          <div className="col-md-4">
            <label className="form-label">Shop Banner Image</label>
            <input
              type="file"
              name="image"
              onChange={handleChange}
              className="form-control"
            />
          </div>

          <div className="col-md-4">
            <label className="form-label">Preview</label>
            <img
              src={
                preview
                  ? preview.includes("cloudinary")
                    ? preview.replace("/upload/", "/upload/w_420,h_260,c_fill,q_auto,f_auto/")
                    : preview
                  : "https://via.placeholder.com/420x260?text=No+Image"
              }
              alt="Shop Banner Preview"
              style={{
                width: "100%",
                height: "160px",
                objectFit: "cover",
                borderRadius: "8px",
                border: "1px solid #ddd"
              }}
            />
          </div>

          <div className="col-12">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                name="active"
                checked={data.active}
                onChange={handleChange}
              />
              <label className="form-check-label">Active</label>
            </div>
          </div>

          <div className="col-12 text-center">
            <button
              type="submit"
              className="mybtnself"
              disabled={btnLoading}
            >
              {btnLoading ? "Please wait..." : "Update Shop Banner"}
            </button>
          </div>

        </form>
      </div>
    </>
  );
};

export default EditShopBanner;
